import { EXTERNAL_LOGIN_PATH } from "../../../../../constants/env";

const CUSTOM_NEXT_URL_SCHEMES = ["bonusx-devx:", "bonusx-testx:", "bonusx-app:"];
const HTTPS_SCHEME = "https:";

function normalizeNextUrlScheme(rawNextUrl: string): string {
  const matchedScheme = CUSTOM_NEXT_URL_SCHEMES.find((scheme) => rawNextUrl.startsWith(scheme));
  if (!matchedScheme) {
    return rawNextUrl;
  }
  return `${HTTPS_SCHEME}${rawNextUrl.slice(matchedScheme.length)}`;
}

export function getSafeNextUrlPath(searchParams: URLSearchParams): string | null {
  const rawNextUrl = searchParams.get("nextURL");
  if (!rawNextUrl) {
    return null;
  }

  const normalizedNextUrl = normalizeNextUrlScheme(rawNextUrl);

  let parsed: URL;
  try {
    parsed = new URL(normalizedNextUrl, window.location.origin);
  } catch {
    return null;
  }

  const isSameOrigin = parsed.origin === window.location.origin;
  if (!isSameOrigin) {
    return null;
  }

  const isExternalLoginLoop = parsed.pathname.startsWith(EXTERNAL_LOGIN_PATH);
  if (isExternalLoginLoop) {
    return null;
  }

  return `${parsed.pathname}${parsed.search}${parsed.hash}`;
}
